import React from "react";
import { Link } from "react-router-dom";
import { useI18n } from "../../lib/i18n";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import SEO from "../../components/SEO";

export default function NotFoundPage() {
  const { t, locale } = useI18n();
  React.useEffect(() => {
    const prer = document.createElement("meta");
    prer.name = "prerender-status-code"; prer.content = "404";
    document.head.append(prer);
    return () => { prer.remove(); };
  }, []);
  return (
    <div className="bg-lin min-h-screen flex flex-col" data-testid="not-found-page">
      <SEO title="404" description={t("notfound.lead")} locale={locale} noindex />
      <Header />
      <main className="flex-1 container-editorial flex items-center justify-center py-32 text-center">
        <div className="max-w-xl">
          <p className="eyebrow mb-6">404</p>
          <h1 className="heading-hero text-domaine text-4xl md:text-5xl mb-6">{t("notfound.title")}</h1>
          <p className="text-lg text-ardoise/80 mb-10">{t("notfound.lead")}</p>
          <Link to="/" className="btn-domaine" data-testid="not-found-home-link">{t("notfound.back")}</Link>
        </div>
      </main>
      <Footer />
    </div>
  );
}
